<template>
<div>
  <v-select
    class="focused-border custom-field full-wide-select-mobile"
    :id="'customFields' + (index + 1)"
    outline
    :items="field.values"
    item-value="value"
    :label="field.mandatory ? getCustomFieldLabel(index) + ' *': getCustomFieldLabel(index)"
    v-model="customPropertySelection"
    :hint="getCustomFieldInfo(index)"
    :persistent-hint="isCustomFieldInfoPersistent(index)"
    :aria-label="getCustomFieldLabelAndInfo(index)"
    :rules="field.mandatory ? [requiredRule] : []"
    chips
    multiple
  >
    <template v-slot:selection="data">
      <v-chip>{{ getCustomFieldValueLabel(data) }}</v-chip>
    </template>
    <template v-slot:item="data">
      <span class="checkbox-icon"><v-icon>{{ isInSelection(data) ? 'check_box' : 'check_box_outline_blank' }}</v-icon></span>
      {{ getCustomFieldValueLabel(data) }}
    </template>
  </v-select>
  <!--DEBUG div>
    {{field}}<br/>
    {{customPropertySelection}}
  </div-->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MultipleSelectionComboBox',
  props: [
    'index',
    'customPropertiesListActive',
    'field'
  ],
  data: () => ({
    requiredRule: false,
    customPropertySelection: []
  }),
  computed: {
    ...mapState([
      'funcDebug',
      'messages',
      'selectedLanguage'
    ])
  },
  watch: {
    customPropertySelection () {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:watch:customPropertySelection')
      let cfsel = {}
      cfsel.parameterName = this.field.parameterName
      cfsel.selection = this.customPropertySelection
      this.$emit('update-cf-selection', cfsel)
    }
  },
  methods: {
    isInSelection (data) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:isInSelection')
      return this.customPropertySelection.find((element) => element === data.item.value)
    },
    getCustomFieldValueLabel (data) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:getCustomFieldValueLabel')
      let labels = data.item.labels
      return labels[this.selectedLanguage.lang]
    },
    isCustomFieldInfoPersistent (index) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:isCustomFieldInfoPersistent')
      if (this.customPropertiesListActive[index].infos[this.selectedLanguage.lang].length > 0) {
        return true
      } else {
        return false
      }
    },
    getCustomFieldLabel (index) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:getCustomFieldLabel')
      return this.customPropertiesListActive[index].labels[this.selectedLanguage.lang]
    },
    getCustomFieldInfo (index) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:getCustomFieldInfo')
      return this.customPropertiesListActive[index].infos[this.selectedLanguage.lang]
    },
    getCustomFieldLabelAndInfo (index) {
      if (this.funcDebug) console.log('MultipleSelectionComboBox:methods:getCustomFieldLabelAndInfo')
      return this.customPropertiesListActive[index].labels[this.selectedLanguage.lang] + ' - ' +
        this.customPropertiesListActive[index].infos[this.selectedLanguage.lang]
    }
  },
  mounted () {
    if (this.funcDebug) console.log('MultipleSelectionComboBox:mounted')
    var _this = this
    this.requiredRule = v => {
      return (v && v.length > 0) || (_this.messages.fieldRequired === undefined ? false : _this.messages.fieldRequired)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-field {
  width: 550px;
  margin: 0 0 0 24px;
}

@media only screen and (max-width: 599px) {
  .full-wide-mobile {
    width:100% !important;
    position: relative !important;
  }
  .full-wide-select-mobile {
    padding: 0 16px !important;
    width: 100% !important;
    margin: 0 !important;
  }
}

.checkbox-icon {
  padding-right: 10px;
}

</style>
